import _ = require('underscore');
import { Messages } from '../../../../codegen/Localize';
import { IDataSourceDetailInfo, IDataSourceInfo } from '../../../../ts/models/IDataSourceInfo';
import { IExtractConvertAction } from '../../../../ts/ServerApi/types/actionNames';
import { changeExtractDsToLive } from '../../../actions/spaces/ChangeExtractDsToLiveAction';
import { selectSpaceInfo } from '../../../selectors/ContentSelectors';
import { SessionSiteSelectors } from '../../../selectors/SessionInfoSelectors';
import { AppState } from '../../../state/AppState';
import { isDatasourceSpace, SpaceInfo } from '../../../state/SpaceInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { extractMoveToTheWebEnabled, hasExtractOnlyDatasource, hasFileBasedDatasource, isSingleDatasourceWithExtract, isSingleLiveDatasource } from './IEntityActionHelpers';

export const ChangeExtractDsToLiveAction: IEntityAction<IDataSourceDetailInfo, IExtractConvertAction> = {
  name: EntityActionNames.ChangeExtractDsToLive,
  translateName: Messages.changeExtractDsToLiveAction,
  isVisible: (targetItems: IDataSourceDetailInfo[], state: AppState) => {
    const isWebExtractionEnabled = SessionSiteSelectors.isWebExtractionEnabled(state);
    if(!extractMoveToTheWebEnabled(isWebExtractionEnabled, targetItems)){
      return false;
    }
    const spaceInfo: SpaceInfo = selectSpaceInfo(state);
    return isDatasourceSpace(spaceInfo) && _.any(targetItems, (targetItem) => targetItem.contentType === 'datasource');
  },
  isClickable: (availableActions: IExtractConvertAction, targetItems: IDataSourceDetailInfo[], state: AppState) => {
    return !(availableActions && !availableActions.extractsToLive) &&
      !hasFileBasedDatasource(targetItems) &&
      !hasExtractOnlyDatasource(targetItems) &&
      isSingleDatasourceWithExtract(targetItems);
  },
  isChecked: (availableActions: {}, targetItems: IDataSourceDetailInfo[], state: AppState) => {
    return isSingleLiveDatasource(targetItems);
  },
  createReduxAction: (dataSources: IDataSourceDetailInfo[]) => changeExtractDsToLive(dataSources)
};
